const PORTAL_PAGES = {
  admin: [
    { slug: "dashboard", route: "/dashboard-admin" },
    { slug: "fleet-management", route: "/fleet-management" },
    { slug: "subscription-payments", route: "/subscription-payments-admin" },
    { slug: "fuel-vendors", route: "/fuel-vendors-admin" },
    { slug: "system-configuration", route: "/system-configuration" },
    { slug: "transactions", route: "/transactions-admin" },
    { slug: "credits-billing", route: "/credits-billings-admin" },
    { slug: "reports-analytics", route: "/reports-analytics" },
    { slug: "approvals-requests", route: "/approvals-requests" },
    { slug: "qr-management", route: "/qr-management" },
    { slug: "user-management", route: "/user-management-admin" },
    { slug: "settings-permissions", route: "/settings-permissions-admin" },
    { slug: "audit-trail", route: "/audit-trail" },
  ],
  manager: [
    { slug: "dashboard", route: "/dashboard-manager" },
    { slug: "vehicles", route: "/vehicles-manager" },
    { slug: "drivers", route: "/drivers-manager" },
    { slug: "fuel-vendors", route: "/fuel-vendors-manager" },
    { slug: "credits-billing", route: "/credits-billings-manager" },
    { slug: "subscription-payments", route: "/subscription-payments" },
    { slug: "transactions", route: "/transactions-manager" },
    { slug: "reports", route: "/reports-manager" },
    { slug: "user-management", route: "/user-management-manager" },
    { slug: "settings-permissions", route: "/settings-permissions-manager" },
    { slug: "audit-trail", route: "/audit-trail-manager" },
    { slug: "company-details", route: "/company-details" },
  ],
  vendor: [
    { slug: "dashboard", route: "/dashboard-vendor" },
    { slug: "transactions", route: "/transactions-vendor" },
    { slug: "settlement", route: "/settlement" },
    { slug: "fuel-pricing", route: "/fuel-pricing" },
    { slug: "fuel-dispensed", route: "/fuel-dispensed" },
    { slug: "audit-trail", route: "/audit-trail-vendor" },
    { slug: "staff-management", route: "/staff-management" },
    { slug: "settings-permissions", route: "/settings-permissions-vendor" },
    { slug: "vendor-details", route: "/vendor-details" },
  ],
};

// Profile pages are not permission-gated, so they're the landing page when
// every other page in the portal is restricted.
const PROFILE_ROUTES = {
  admin: "/profile-admin",
  manager: "/profile-manager",
  vendor: "/profile-vendor",
};

const isAllowed = (pageAccess, slug) => (pageAccess || {})[slug] !== "restrict";

const getFirstAllowedRoute = (userType, pageAccess, fallbackRoute) => {
  const pages = PORTAL_PAGES[userType];
  if (!pages) return fallbackRoute;

  const firstAllowed = pages.find((page) => isAllowed(pageAccess, page.slug));

  if (firstAllowed) return firstAllowed.route;

  return PROFILE_ROUTES[userType] || fallbackRoute;
};

export { getFirstAllowedRoute, PORTAL_PAGES, PROFILE_ROUTES };
export default getFirstAllowedRoute;
